import { tsValidate, tsValidateDynamicObject, tsValidateMustExist, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { PopulationType_General, PopulationType_Specific } from './types.js';
export const Validator_Population_General = {
    type: tsValidateValue([PopulationType_General]),
};
export const Validator_Population_Specific = {
    type: tsValidateValue([PopulationType_Specific]),
    specifications: tsValidateDynamicObject(tsValidateUniqueId, tsValidateUniqueId)
};
export const Validator_Population = (instance) => {
    const error = tsValidate(instance, tsValidateMustExist);
    if (error)
        return error;
    if (instance.type === PopulationType_General)
        return tsValidate(instance, Validator_Population_General);
    if (instance.type === PopulationType_Specific)
        return tsValidate(instance, Validator_Population_Specific);
    // @ts-ignore
    return `Missing validator for population of type ${instance?.type}`;
};
//# sourceMappingURL=validator.js.map